<template>
  <div id="vue">
    <div class="progressBg">
      <van-circle
        v-model="currentRate"
        :stroke-width="30"
        :rate="100"
        :speed="25"
        size="4rem"
        color="#D93C3A"
        layer-color="none"
      >
      </van-circle>
      <img
        src="../../assets/images/stateWating/progress_bg.png"
        class="progressImage"
      />
      <div class="progressLab">{{ currentRate }}%</div>
    </div>

    <div class="state-txt">
      <div class="flex-row">
        <div :class="step >= 1 ? 'txt-active' : ''">身份信息确认</div>
        <div :class="step >= 1 ? 'prepare-active' : 'prepare'"></div>
      </div>
      <div class="flex-row">
        <div :class="step >= 2 ? 'txt-active' : ''">正在提交资料</div>
        <div :class="step >= 2 ? 'prepare-active' : 'prepare'"></div>
      </div>
      <div class="flex-row">
        <div :class="step >= 3 ? 'txt-active' : ''">正在进行初审</div>
        <div :class="step >= 3 ? 'prepare-active' : 'prepare'"></div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API_Common from "@/api/common.js";
import { toRedirectUrlAndSaveRecordNoDebounce } from "@/api/common.js";
import Cookies from "js-cookie";
export default {
  name: "stateWatingModel8",
  data() {
    return {
      source: "",
      code: this.$route.query.code,
      persent: 0,
      step: 1,
      currentRate: 0,
      rate: 0,
      timer: null,
      second: 0,
      minute: 0,
      unionToken: this.$route.query.token,
      apiProduct: {
        imgUrl: "",
        thirdPartyId: "",
        productId: "",
        companyName: "",
        name: "",
        userId: "",
        content: "",
        redirectUrl: "",
        grantValue: "",
        grantApiLists: [],
      },
      recommendProduct: {},
      unionLogin: {
        productId: 0,
        url: "",
      },
    };
  },
  mounted() {
    this.initState();
    this.autoToHref();
    window.localStorage.removeItem("cytClosePop");
    this.source = this.$route.query.source;
    if (this.unionToken) {
      console.log("unionToken:" + this.unionToken);
      this.getUnionToken(this.unionToken);
    }
  },

  methods: {
    //API机构和授权书
    async getAPIProduct() {
      const model = sessionStorage.getItem("model");
      if (model === "model14") {
        //海尔渠道单独处理
        this.$router.replace({
          name: "stagingAssessmentModelHaier",
          query: { source: this.source },
        });
        return;
      }
      try {
        const res = await API_Common.getProductByUserV2(this.source);
        if (res?.data?.api.length) {
          this.$router.replace({
            name: "matchingResults",
            query: { source: this.source },
          });
        } else {
          const isBiddingItem = res.data.cpa?.find((e) => e.isBidding == 1);
          if (isBiddingItem) {
            localStorage.setItem("bidding_item", JSON.stringify(isBiddingItem));
            this.$router.replace({
              name: "matchingResults_cpa",
              query: { source: this.source },
            });
            return false;
          }
          if (this.source === "7CUYBjpWop") {
            //微博渠道直接跳转
            this.handlePushApiResult();
          } else {
            this.getChannleProductList();
          }
        }
      } catch (error) {
        this.handlePushApiResult();
      }
    },
    // 根据渠道code读取产品推荐信息 将权重最大的进行显示
    getChannleProductList() {
      API_Common.getProductsInResultPage(this.source).then((res) => {
        if (res.code === 200) {
          let dataArr = res.data;
          if (dataArr.length > 0) {
            this.recommendProduct = dataArr[0];
            this.handleProductResult();
          } else {
            this.handlePushApiResult();
          }
        } else {
          this.handlePushApiResult();
        }
      });
    },
    //根据返回不同的产品类型 调用不同接口
    handleProductResult() {
      let redirectUrl = this.recommendProduct.linkUrl; // 默认跳转 URL
      let isWeCom = this.recommendProduct.isWeCom;
      let userId = window.localStorage.getItem("userId");
      const buriedData = {
        channel: this.source,
        userId: userId,
        productId: this.recommendProduct.id,
        showPage: 5,
      };
      if (this.recommendProduct.isToRegister === 1) {
        API_Common.getRegister2CompanyUrl(
          this.recommendProduct.id,
          this.recommendProduct.hitRecordId
        )
          .then(async (res) => {
            await this.handlePushApiResult();
            if (res.code === 200 && res.data) {
              redirectUrl = res.data;
            } else {
              console.warn("getRegister2CompanyUrl 返回数据异常，使用默认 URL");
            }
          })
          .catch(async (error) => {
            await this.handlePushApiResult();
          })
          .finally(() => {
            //无论api成功或者失败 都执行跳转和埋点
            toRedirectUrlAndSaveRecordNoDebounce(
              redirectUrl,
              buriedData,
              isWeCom
            );
          });
      } else if (this.recommendProduct.isToRegister === 3) {
        var that = this;
        API_Common.getUnionLogin4ClickV3(
          that.recommendProduct.id,
          that.recommendProduct.hitRecordId
        )
          .then(async (res) => {
            await that.handlePushApiResult();
            that.unionLogin = res.data;
          })
          .catch(async (error) => {
            await that.handlePushApiResult();
          })
          .finally(() => {
            toRedirectUrlAndSaveRecordNoDebounce(
              that.unionLogin.url,
              {
                channel: that.source,
                userId: userId,
                productId: that.recommendProduct.id,
                showPage: 5,
              },
              isWeCom
            );
          });
      } else {
        this.handlePushApiResult();
      }
    },
    getUnionToken(unionToken) {
      API_Common.getUnionToken(unionToken).then((res) => {
        if (res.code === 200) {
          Cookies.set("token", res.data.token);
          window.localStorage.setItem("userId", res.data.userId);
        } else {
          this.$toast(res.msg);
        }
      });
    },
    handlePushApiResult() {
      const routeName =
        this.source === "paipai4" ? "capResults" : "auditResult";
      this.$router.replace({
        name: routeName,
        query: { source: this.source },
      });
    },
    initState() {
      var that = this;
      var intervalFunc = setInterval(function () {
        if (that.persent === 99) clearInterval(intervalFunc);
        that.persent++;
        that.modifyTxt(that.persent);
        that.persentWidth++;
      }, 35);
    },
    autoToHref() {
      var that = this;
      setTimeout(function () {
        that.getAPIProduct();
      }, 4000);
    },

    modifyTxt(num) {
      switch (num) {
        case 0:
          this.step = 1;
          break;
        case 33:
          this.step = 2;
          break;
        case 100:
          this.step = 3;

          break;
      }
    },
  },
};
</script>
<style scoped></style>
<style lang="scss" scoped>
#vue {
  height: 100vh;
  overflow: auto;
  background: url("../../assets/images/stateWating/bg.png") no-repeat;
  background-size: cover;
  /* padding: 0.3rem 0.35rem; */
}
.progressBg {
  width: 100%;
  height: 4rem;
  text-align: center;
  margin-top: 1rem;
  position: absolute;
}

.progressImage {
  width: 4rem;
  height: 4rem;
  background: url("../../assets/images/stateWating/progress_bg.png") no-repeat;
  background-size: cover;
  position: absolute;
  margin-left: -53%;
}
.progressLab {
  text-align: center;
  font-size: 14px;
  position: absolute;
  z-index: 10;
  margin-top: -22%;
  margin-left: 46.5%;
}

@keyframes spin {
  to {
    transform: rotateZ(360deg);
  }
}

.line-ani {
  position: relative;
  width: 80vw;
  top: 1.5rem;
  height: 2px;
  margin: 0 auto;
  border: 2px solid #ceddfc;
  border-radius: 1px;
}

.line-active {
  height: 2px;
  /* width: 20vw; */
  border: 2px solid #3b75f6;
  margin-top: -2.5px;
  /* animation: myfirst 4s 1; */
}

.pop {
  width: 0.5rem;
  height: 0.3rem;
  /* margin: 0 auto; */
  margin-top: -0.4rem;
  /* left: 20%; */
  background: url("../../assets/images/stateWating/pop.png") no-repeat;
  background-size: cover;
  position: absolute;
  color: #ffffff;
  line-height: 0.3rem;
  font-size: 0.2rem;
  margin-left: -15px;
}

.state-txt {
  width: 80vw;
  position: relative;
  margin: 0 auto;
  top: 7rem;
}

.flex-row {
  display: flex;
  font-size: 0.3rem;
  margin-top: 25px;
  justify-content: space-between;
  color: #babdd0;
}

.txt-active {
  color: #000000;
}

.prepare {
  width: 0.32rem;
  height: 0.3rem;
  background: url("../../assets/images/stateWating/prepare.png") no-repeat;
  background-size: cover;
}

.prepare-active {
  width: 0.32rem;
  height: 0.3rem;
  background: url("../../assets/images/stateWating/prepare-active.png")
    no-repeat;
  background-size: cover;
}
</style>
